import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TerminalOrangeButton from '../ui/TerminalOrangeButton';
import { terminalColors } from '../../theme/terminalStyles';

const AUTO_CLOSE_SEC = 5;

const PickingScanErrorDialog = ({ open, variant, product, onClose }) => {
  const [secondsLeft, setSecondsLeft] = useState(AUTO_CLOSE_SEC);

  useEffect(() => {
    if (!open) return undefined;
    setSecondsLeft(AUTO_CLOSE_SEC);
    const tick = window.setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          window.clearInterval(tick);
          onClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => window.clearInterval(tick);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps -- таймер лише при відкритті

  const title =
    variant === 'not_in_document'
      ? 'Помилка! Даний товар відсутній в документі'
      : 'Даний товар вже було зібрано!';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent sx={{ textAlign: 'center', py: 3, px: 3 }}>
        <ErrorOutlineIcon sx={{ fontSize: 72, color: '#d32f2f', mb: 1 }} />
        <Typography variant="h6" sx={{ px: 0.5, mb: 1.5 }}>
          {title}
        </Typography>
        {product ? (
          <Typography
            component="div"
            variant="body1"
            sx={{ color: terminalColors.textPrimary, textAlign: 'left', px: 1 }}
          >
            {product.article != null && product.article !== '' ? (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                Артикул: <strong>{product.article}</strong>
              </Typography>
            ) : null}
            <Typography variant="body1" fontWeight={600} sx={{ mb: 0.75 }}>
              {product.name || '—'}
            </Typography>
            {variant === 'already_collected' &&
            product.doc != null &&
            product.fact != null ? (
              <Typography variant="body2" color="text.secondary">
                Док: {product.doc} · Зібрано: {product.fact}
              </Typography>
            ) : null}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <TerminalOrangeButton onClick={onClose}>
          OK ({secondsLeft})
        </TerminalOrangeButton>
      </DialogActions>
    </Dialog>
  );
};

export default PickingScanErrorDialog;
